export const MODAL_SIZE_SM = 'sm';
export const MODAL_SIZE_MD = 'md';
export const MODAL_SIZE_LG = 'lg';
export const MODAL_SIZE_XL = 'xl';

export type ModalSize = 'sm' | 'md' | 'lg' | 'xl';

export const MODAL_PHONE_MAX_WIDTH_PX = 600;
